import { AxiosPromise } from 'axios'

import api from '@config/api'

export function postOtbPlansData(data: any): AxiosPromise {
  return api.post('v1/OTB/Planos', data)
}

export function postOtbPlansExportData(data: any): AxiosPromise {
  return api.post('v1/OTB/Planos/Exportar', data)
}

export function putOtbFinalStorageAdjustedData(data: any): AxiosPromise {
  return api.put('v1/OTB/Planos/EstoqueFinalAjustado', data)
}

export default {
  postOtbPlansData,
  postOtbPlansExportData,
  putOtbFinalStorageAdjustedData
}
